import { Link } from 'react-router-dom';

// material-ui
import { ButtonBase, Box } from '@mui/material';

// project imports
import zeutecConfig from '../../../zeutecConfig';
import Logo from 'ui-component/Logo';

// new logo
import GrainLogo from 'assets/images/SPA_grain_logo.svg';

const LogoSection = () => (
    <ButtonBase disableRipple component={Link} to={zeutecConfig.defaultPath}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Logo />

            <Box
                component="img"
                src={GrainLogo}
                alt="grain logo"
                marginTop={0.7}
                sx={{
                    height: 32, // match zeutec logo height
                    width: 'auto'
                }}
            />
        </Box>
    </ButtonBase>
);

export default LogoSection;